/**
 * Versione dell'applicazione.
 * Questo file viene generato automaticamente dallo script update-version.js
 * basandosi sulla versione nel package.json.
 * NON modificare manualmente questo file.
 */
export const APP_VERSION = '2.3.51';
